import Vue from "vue";
import Router from "vue-router";

// screens
import MainLayout from "../screens/MainLayout";
import Event from "../screens/events/Event";
// import EventDetail from "../screens/events/EventDetail";
const EventDetail = () => import("../screens/events/EventDetail");
// import Service from "../screens/services/MainService";
// import ServiceGroupVisit from "../screens/services/ServiceGroupVisit";

// import AboutMain from "../screens/about/AboutMain";
// import AboutBranch from "../screens/about/AboutBranch";
// import AboutMiniTcdc from "../screens/about/AboutMiniTcdc";
// import AboutNews from "../screens/about/AboutNews";

// import ResourceCenterLayout from "../screens/resource_center/ResourceCenterLayout";
// import ResourceCenter from "../screens/resource_center/ResourceCenter";
// import Article from "../screens/resource_center/Article";
// import ArticleDetail from "../screens/resource_center/ArticleDetail";
// import Database from "../screens/resource_center/Database";
// import DesignCalendar from "../screens/resource_center/DesignCalendar";
// import Ebook from "../screens/resource_center/Ebook";
// import EbookDetail from "../screens/resource_center/EbookDetail";
// import Material from "../screens/resource_center/Material";
// import OnlineExhibition from "../screens/resource_center/OnlineExhibition";
// import OnlineExhibitionDetail from "../screens/resource_center/OnlineExhibitionDetail";
// import TCDCResourceCenter from "../screens/resource_center/TCDCResourceCenter";

// import OurService from "../screens/our_service/OurService";
const OurService = () => import("../screens/our_service/OurService");

// import FAQS from "../screens/FAQS/FAQS";
const Faqs = () => import("../screens/FAQS/FAQS");
// import MembershipService from "../screens/services/MembershipService";
// import ResouceCenterService from "../screens/services/ResouceCenterService";
// import ConsultService from "../screens/services/ConsultService";
// import VentureHireService from "../screens/services/VentureHireService";
// import VisitServiceArea from "../screens/services/VisitServiceArea";
// import NewsDetail from "../components/news_layout/NewsDetail";
// import DesignCalendarDetail from "../screens/resource_center/DesignCalendarDetail";
// import Enewsletter from "../screens/Enewsletter/Enewsletter";
const Enewsletter = () => import("../screens/Enewsletter/Enewsletter");
import Search from "../screens/Search/Search";
// import Notfound from "../screens/Notfound";
const Notfound = () => import("../screens/Notfound");

// import FreePage from "../screens/freepage/FreePage";
const FreePage = () => import("../screens/freepage/FreePage");
// import IdeaService from "../screens/our_service/sub_ourservices/IdeaService";
const IdeaService = () => import("../screens/our_service/sub_ourservices/IdeaService");

// import BizStartupService from "../screens/our_service/sub_ourservices/BizStartupService";
const BizStartupService = () => import("../screens/our_service/sub_ourservices/BizStartupService");
// import BizTransformService from "../screens/our_service/sub_ourservices/BizTransformService";
const BizTransformService = () => import("../screens/our_service/sub_ourservices/BizTransformService");
// import {serviceResourceCenterRouter} from "@/router/branches/service-resource-center";
// import {serviceRouter} from "@/router/branches/service";
// import {aboutRouter} from "@/router/branches/about";
import branchesRouter from  "./branches"
// import OurServicePage from "../screens/our_service/sub_ourservices/OurServicePage";
const OurServicePage = () => import("../screens/our_service/sub_ourservices/OurServicePage");
// import TagSearch from "@/screens/Search/TagSearch"
const TagSearch = () => import("../screens/Search/TagSearch");

// import store from "../store";

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/landing",
            name: "LandingPage",
            component: () => import("../screens/LandingPage")
        },
        {
            path: "/",
            name: "Redirect",
            component: () => import("../screens/LandingPage")
        },
        {
            path: "/:lang",
            name: "MainLayout",
            component: MainLayout,
            children: [
                {
                    path: "home",
                    name: "EventMain",
                    component: Event,
                },
                {
                    path: "home/:branch",
                    name: "EventBranch",
                    component: Event,
                },
                {
                    path: ":branch/events/:id",
                    name: "EventDetail",
                    component: EventDetail,
                },
                ...branchesRouter.serviceRouter,
                ...branchesRouter.serviceResourceCenterRouter,
                ...branchesRouter.aboutRouter,
                {
                    path: "our-service/:id",
                    name: "OurService",
                    component: OurServicePage,
                },
                /*
              {
                path: "/service/resource-center",
                name: "ResCenterService",
                component: ResouceCenterService,
              },
              {
                path: "/service/resource-center",
                name: "ResourceCenterLayout",
                component: ResourceCenterLayout,
                children: [
                  {
                    path: "/service/resource-center",
                    name: "ResourceCenter",
                    component: ResourceCenter,
                  },
                  {
                    path: "/service/resource-center/article",
                    name: "Article",
                    component: Article,
                    props: {
                      showHeader: true,
                    },
                  },
                  {
                    path: "/service/resource-center/article/:id",
                    name: "ArticleDetail",
                    component: ArticleDetail,
                  },
                  {
                    path: "/service/resource-center/database/:branch",
                    name: "Database",
                    component: Database,
                    props: {
                      showHeader: true,
                    },
                  },
                  {
                    path: "/service/resource-center/database",
                    name: "Database",
                    component: Database,
                    props: {
                      showHeader: true,
                    },
                  },
                  {
                    path: "/service/resource-center/design-world-calendar",
                    name: "DesignCalendar",
                    component: DesignCalendar,
                    props: {
                      showHeader: true,
                    },
                  },
                  {
                    path: "/service/resource-center/design-world-calendar/:id",
                    name: "DesignCalendarDetail",
                    component: DesignCalendarDetail
                  },
                  {
                    path: "/service/resource-center/e-book",
                    name: "Ebook",
                    component: Ebook,
                    props: {
                      showHeader: true,
                    },
                  },
                  {
                    path: "/service/resource-center/e-book/:id",
                    name: "EbookDetail",
                    component: EbookDetail,
                  },
                  {
                    path: "/service/resource-center/material/:branch",
                    name: "Material",
                    component: Material,
                    props: {
                      showHeader: true,
                    },
                  },
                  {
                    path: "/service/resource-center/material",
                    name: "Material",
                    component: Material,
                    props: {
                      showHeader: true,
                    },
                  },
                  {
                    path: "/service/resource-center/online-exhibition",
                    name: "OnlineExhibition",
                    component: OnlineExhibition,
                    props: {
                      showHeader: true,
                    },
                  },
                  {
                    path: "/service/resource-center/online-exhibition/:id",
                    name: "OnlineExhibitionDetail",
                    component: OnlineExhibitionDetail
                  },
                  {
                    path: "/service/resource-center/tcdc-resource-center/:branch",
                    name: "TCDCResourceCenter",
                    component: TCDCResourceCenter,
                    props: {
                      showHeader: true,
                    },
                  },
                  {
                    path: "/service/resource-center/tcdc-resource-center",
                    name: "TCDCResourceCenter",
                    component: TCDCResourceCenter,
                    props: {
                      showHeader: true,
                    },
                  },
                  {
                    path: "/service/resource-center/:branch",
                    name: "ResCenterService",
                    component: ResouceCenterService,
                  },
                ],
              },
                */
                /*
              {
                path: "/service/:branch",
                name: "Service",
                component: Service,
                props: true
              },
              {
                path: "/service",
                name: "Service",
                component: Service,
                props: true
              },
              {
                path: "/service/membership/:branch",
                name: "MembershipService",
                component: MembershipService,
              },
              {
                path: "/service/membership",
                name: "MembershipService",
                component: MembershipService,
              },
              {
                path: "/service/consult/:branch",
                name: "ConsultService",
                component: ConsultService,
              },
              {
                path: "/service/consult",
                name: "ConsultService",
                component: ConsultService,
              },
              {
                path: "/service/venue-hire/:branch",
                name: "VentureHireService",
                component: VentureHireService,
              },
              {
                path: "/service/venue-hire",
                name: "VentureHireService",
                component: VentureHireService,
              },
              {
                path: "/service/visit-and-service-area/:branch",
                name: "VisitServiceArea",
                component: VisitServiceArea,
              },
              {
                path: "/service/visit-and-service-area",
                name: "VisitServiceArea",
                component: VisitServiceArea,
              },
              {
                path: "/service/group-visit-detail/:branch",
                name: "ServiceGroupVisitDetail",
                component: ServiceGroupVisit,
              },
              {
                path: "/service/group-visit-detail",
                name: "ServiceGroupVisitDetail",
                component: ServiceGroupVisit,
              },
              */
                // {
                //     path: "/about-main",
                //     name: "AboutMain",
                //     component: AboutMain,
                // },
                {
                    path: "/:lang/enewsletter",
                    name: "Enewsletter",
                    component: Enewsletter,
                },
                {
                    path: "/search",
                    name: "Search",
                    component: Search,
                },
                {
                    path: "/tag-search",
                    name: "TagSearch",
                    component: TagSearch,
                },
                // {
                //     path: "/about/news/:branch/:id",
                //     name: "NewsDetail",
                //     component: NewsDetail,
                // },
                // {
                //     path: "/about/news/:branch",
                //     name: "AboutNews",
                //     component: AboutNews,
                // },
                // {
                //     path: "/about/:branch",
                //     name: "AboutBranch",
                //     component: AboutBranch,
                // },
                {
                    path: "our-service",
                    name: "OurService",
                    component: OurService,
                },
                {
                    path: "/our-service/idea-generation",
                    name: "IdeaService",
                    component: IdeaService,
                },
                {
                    path: "/our-service/business-startup",
                    name: "BizStartupService",
                    component: BizStartupService,
                },
                {
                    path: "/our-service/business-transformation",
                    name: "BizTransformService",
                    component: BizTransformService,
                },
                // {
                //     path: "/about/mini-tcdc/:branch",
                //     name: "AboutMiniTcdc",
                //     component: AboutMiniTcdc,
                // },
                // {
                //     path: "/faqs/:branch",
                //     name: "Faqs",
                //     component: FAQS,
                // },
                {
                    path: "/faqs",
                    name: "Faqs",
                    component: Faqs
                },
                {
                    path: "/:lang?/:slug",
                    name: "FreePage",
                    component: FreePage
                },
                {
                    path: "*",
                    name: "Notfound",
                    component: Notfound
                }
            ],
        }
    ],
});

router.beforeEach((to, from, next) => {
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 100);
    return next();
});

export default router;
